<template>
  <div class="container">
    <event-translation
      @add="activeStep = 2"
      @edit=";(activeStep = 3), setSelectedLanguage($event)"
      v-if="activeStep === 1"
      :initial-values="translations"
    />
    <new-translation
      v-if="activeStep === 2"
      :attendee-fields="list"
      @cancel="activeStep = 1"
      :eventId="this.eventId"
      @saved=";(activeStep = 1), refetchData()"
    />
    <edit-translation
      v-if="activeStep === 3"
      :eventId="this.eventId"
      :existingTranslations="existingTranslations"
      :languages="translations"
      :attendee-fields="list"
      :selectedLanguage="selectedLanguage"
      @cancel="activeStep = 1"
      @delete=";(activeStep = 1), refetchData()"
      @submit=";(activeStep = 1), refetchData()"
    />
  </div>
</template>

<script>
import NewTranslation from './new-translation.vue'
import EventTranslation from './event-translation.vue'
import EditTranslation from './edit-translation.vue'
import { ATTENDEE_FIELDS } from '../../graphql/event.graphql'
import { GET_TRANSLATION } from '../../graphql/translation.graphql'

export default {
  name: 'translate-container',
  components: {
    NewTranslation,
    EventTranslation,
    EditTranslation,
  },
  props: {
    eventId: {
      default: null,
      type: String,
    },
  },
  data() {
    return {
      activeStep: 1,
      list: null,
      allLanguages: require('../../assets/languages.json'),
      translations: [],
      existingTranslations: {},
    }
  },
  methods: {
    async refetchData() {
      await this.$apollo.queries.getTranslation.refetch()
    },
    setSelectedLanguage(language) {
      this.selectedLanguage = language
    },
  },
  apollo: {
    getTranslation: {
      query: GET_TRANSLATION,
      variables() {
        return {
          eventId: Number(this.eventId),
        }
      },
      manual: true,
      result({ data: { getTranslation }, loading }) {
        if (!loading) {
          this.existingTranslations = getTranslation.translationsJSON
          this.translations = []
          const isoLanguageShort = Object.keys(getTranslation.translationsJSON)
          Object.entries(this.allLanguages).find(([key, value]) => {
            if (isoLanguageShort.includes(key)) {
              this.translations.push(value.name)
            }
          })
        }
      },
    },
    getLanguageCodesForEvent: {
      query: ATTENDEE_FIELDS,
      variables() {
        return {
          eventId: this.eventId,
        }
      },
      manual: true,
      result({
        data: {
          getEvent: { attendeeFields },
        },
        loading,
      }) {
        if (!loading) {
          this.list = Object.keys(attendeeFields)
        }
      },
    },
  },
}
</script>

<style scoped>
.add-icon {
  width: 0.75rem;
  height: 0.75rem;
  margin-right: 0.5rem;
}
.container {
  max-width: 700px;
  align-items: flex-start;
  margin: 0 !important;
  padding: 0 !important;
}
@media screen and (max-width: 800px) {
  .container {
    margin-top: 1.5rem;
  }
}
</style>
